// src/context/UploadAssetContext.tsx

import { createContext, useContext } from 'react';
// We import the hook itself just to get its return type automatically.
// This ensures our context and hook are always perfectly in sync.
import { useUploadAsset } from '../hooks/asset/useUploadAsset';

/**
 * This is the magic. `ReturnType<typeof useUploadAsset>` automatically creates a type
 * that matches whatever the useUploadAsset hook returns. If you add something to the
 * hook's return object, this type updates automatically.
 */
export type IUploadAssetContext = ReturnType<typeof useUploadAsset>;

/**
 * The context is created to hold a value of that specific shape.
 */
export const UploadAssetContext = createContext<IUploadAssetContext | null>(null);

/**
 * The consumer hook remains the same. It's simple and does its job perfectly.
 */
export const useUploadAssetContext = () => {
  const context = useContext(UploadAssetContext);
  if (!context) {
    throw new Error("useUploadAssetContext must be used within an UploadAssetContext.Provider");
  }
  return context;
};